import React, { useEffect, useState, useRef, lazy } from "react";
import axios from "axios";
import { CloseCircleFilled } from "@ant-design/icons";
import RevisionsExpandedRow from "./revisionsExpandedRow";
import ReceivedIcon from "../../../../assets/received_icon.png";
import InProgressIcon from "../../../../assets/in_progress.png";
import CompletedIcon from "../../../../assets/completed.png";
import OnHoldIcon from "../../../../assets/476dab3b4f69c5886bdab2c64c134f28_e20f00.svg";
import {
  Table,
  Input,
  Button,
  Popconfirm,
  Form,
  Col,
  Row,
  Space,
  Dropdown,  
  Tag,
  Menu,
  Checkbox,
} from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { PlusOutlined, DeleteOutlined, EditOutlined, ExclamationCircleOutlined, UpCircleOutlined, DownCircleOutlined } from "@ant-design/icons";
import { ReactComponent as AttachIcon } from "../../../../assets/attach.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/cross-icon.svg";
import * as actions from "./redux/actions";
import * as userManagerActions from "../../../UserManager/redux/actions";
import SpinnerComponent from "../../../../components/spinner";
import NonEditRowAttach from "./nonEditRowAttachView";
import CustomCalendar from "../../../../components/calendar";
import RevisionsEditableCell from "./revisionsEditableCell";
import AMultiSelect from "../../../../components/AMultiSelect";
import _ from "lodash";
import { getOptions } from "../../utils";
import { useParams } from "react-router-dom";
import UseRevisionsPermissions from "../../permissions/useRevisionsPermissions";
import ReactDOM from "react-dom";
import "./revisionsTable.less";

function RivisionsTable({ parentRecordID, type, orgRecordId, uniqueId, record, mcPermissions }) {
  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState("");
  const [sortedInfo, setSortedInfo] = useState(null);
  const [editingLoading, setEditingLoading] = useState(false);
  const [currentUpdateObj, setCurrentUpdateObj] = useState({});
  const [form] = Form.useForm();
  const [fieldsFormRef] = Form.useForm(); // Form reference for expanded row
  const dispatch = useDispatch();
  const [images, setImages] = useState([]);
  // images contains all attachments of item
  const [attachPopupVisible, setAttachPopupVisible] = useState(false);
  const [search, setSearch] = useState({});
  const [date, setDate] = useState(null);
  const [statusCheckedList, setStatusCheckedList] = useState([]);
  const [deletingActivityId, setDeleteActivityId] = useState();
  const [showTable, setShowTable] = useState(false);
  const [req, setReq] = useState(false);
  const { project_id } = useParams();
  const [canView, canEdit, canDelete] = UseRevisionsPermissions();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [fields, setFields] = useState([]);
  const [viewMode, setViewMode] = useState(false);
  const lastExpandedRowRef = useRef(null);
  
  // Area filter state
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [areaOptions, setAreaOptions] = useState([]);
  const [areaDropdownVisible, setAreaDropdownVisible] = useState(false);
  
  // Priority filter state
  const [priorities, setPriorities] = useState([]);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [priorityDropdownVisible, setPriorityDropdownVisible] = useState(false);
  
  // Tracking status options - shared by all tracking status filters
  const trackingStatusOptions = [
    { label: 'Not Started', value: 'not_started' },
    { label: 'In Progress', value: 'in_progress' },
    { label: 'Completed', value: 'completed' },
    { label: 'Received', value: 'received' }
  ];
  
  // Tracking status filter states
  const [fabricationStatusFilter, setFabricationStatusFilter] = useState([]);
  const [fabricationDropdownVisible, setFabricationDropdownVisible] = useState(false);
  
  const [qcReleaseStatusFilter, setQcReleaseStatusFilter] = useState([]);
  const [qcReleaseDropdownVisible, setQcReleaseDropdownVisible] = useState(false);
  
  const [corrosionProtectionStatusFilter, setCorrosionProtectionStatusFilter] = useState([]);
  const [corrosionProtectionDropdownVisible, setCorrosionProtectionDropdownVisible] = useState(false);
  
  const [deliveryToSiteStatusFilter, setDeliveryToSiteStatusFilter] = useState([]);
  const [deliveryToSiteDropdownVisible, setDeliveryToSiteDropdownVisible] = useState(false);
  
  const [siteReceiptStatusFilter, setSiteReceiptStatusFilter] = useState([]);
  const [siteReceiptDropdownVisible, setSiteReceiptDropdownVisible] = useState(false);
  
  const [installationStatusFilter, setInstallationStatusFilter] = useState([]);
  const [installationDropdownVisible, setInstallationDropdownVisible] = useState(false);

  // Revision dropdown state
  const [revisionOptions, setRevisionOptions] = useState([]);
  const [revisionDropdownVisible, setRevisionDropdownVisible] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const addRevisionButtonRef = useRef(null);

  const isEditing = (record) =>
    record.key === editingKey || record.id === editingKey;

  const {
    allProjectRevisions,
    fetchingLoading,
    updateLoading,
    isAddProjectRevision,
    isUpdateProjectRevision,
    deletingLoading,
  } = useSelector((state) => state.projectRevisionsReducer);

  const { user } = useSelector((state) => state.authReducer);
  // const { user_projects, fetchUserDetailLoading } = useSelector((state) => state.userManagerReducer || {});
  
  // // Ensure user_projects is loaded
  // useEffect(() => {
  //   if (!user_projects || user_projects.length === 0) {
  //     dispatch(userManagerActions.fetchAllUserProjects({}));
  //   }
  // }, [dispatch, user_projects]);
  
  // const projectIdNum = parseInt(project_id);
  // const currentProject = user_projects?.find(
  //   (project) => parseInt(project.projectId) === projectIdNum || project.projectId === project_id
  // );
  // const revisionsPermissions = currentProject?.permissions?.edit?.add_revisions || false;


  const handleUpdateStatus = (isAdd, isUpdate) => {
    dispatch(
      actions.updateProjectRevisionsIsAddIsUpdate({
        isAddProjectRevision: isAdd,
        isUpdateProjectRevision: isUpdate,
      })
    );
  };
  const getColumnName = (i) => {
    const columnNames = [
      "Area",
      "Assembly No",
      "Rev",
      "Unique Id",
      "Qty",
      "Material Type",
      "Total/Gross",
      "Priority",
      "Fabrication",
      "QC Release",
      "CORROS. PROT.\n/DEL. WRKSHP.",
      "Delivery to Site",
      "Site Receipt",
      "% Compl.",
      "% Instl."
    ];
    return columnNames[i] || `Column ${i + 1}`;
  };

  const handleColOnClick = (record, e) => {
    // Stop event propagation to prevent parent table events from interfering
    if (e) e.stopPropagation();
    
    // Get the record ID
    const recordId = record.id;
    
    // Toggle expanded row - if already expanded, collapse it; otherwise expand it
    if (expandedRowKeys.includes(recordId)) {
      setExpandedRowKeys([]);
      // Clear the reference when collapsing
      lastExpandedRowRef.current = null;
    } else {
      // Save the current record ID to reference later
      lastExpandedRowRef.current = recordId;
      
      // Set up fields for the expanded row based on record type
      setupFieldsForRecord(record);
      
      // Expand this row
      setExpandedRowKeys([recordId]);
    }
  };
  
  // Function to set up fields for the expanded row based on record type
  const setupFieldsForRecord = (record) => {
    let type = record.type || "material";
    
    if (type === "material") {
      type = "Material";
    } else if (type === "bolts") {
      type = "Bolts";
    }

    // Initialize fields for the form
    if (type === "Material") {
      // Set predefined fields for material form based on the image
      const materialFields = [
        { id: "areaName", name: "AREA NAME", field_type: "text_field", required: true },
        { id: "originalPriorityId", name: "ORIGINAL PRIORITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "newPriorityId", name: "NEW PRIORITY", field_type: "select_field", field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "unitSubtotal", name: "UNIT SUBTOTAL / NET", field_type: "text_field", required: true },
        { id: "model", name: "MODEL", field_type: "text_field" },
        { id: "profileMember", name: "PROFILE / MEMBER", field_type: "text_field", required: true },
        { id: "materialSpec", name: "MATERIAL SPEC", field_type: "text_field", required: true },
        { id: "length", name: "LENGTH (mm)", field_type: "text_field", required: true },
        { id: "paintArea", name: "PAINT AREA EACH (m²)", field_type: "text_field" },
        { id: "supplierId", name: "SUPPLIER", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Supplier 1" },
          { id: 2, name: "Supplier 2" },
          { id: 3, name: "Supplier 3" }
        ] },
        { id: "commodityId", name: "COMMODITY", field_type: "select_field", field_options: [
          { id: 1, name: "Commodity 1" },
          { id: 2, name: "Commodity 2" },
          { id: 3, name: "Commodity 3" }
        ] },
        { id: "attachments", name: "ATTACHMENTS", field_type: "upload_field" },
        { id: "comments", name: "COMMENTS", field_type: "text_field" },
        { id: "status", name: "STATUS", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Active" },
          { id: 2, name: "Inactive" },
          { id: 3, name: "Pending" }
        ] },
        { id: "createdById", name: "CREATED BY", field_type: "text_field", disabled: true },
        { id: "createdDate", name: "CREATED DATE & TIME", field_type: "date_field", disabled: true },
        { id: "updatedById", name: "MODIFIED BY", field_type: "text_field", disabled: true },
        { id: "modifiedDate", name: "MODIFIED DATE & TIME", field_type: "date_field", disabled: true },
      ];
      setFields(materialFields);
    } else if (type === "Bolts") {
      // Set predefined fields for bolts form based on the image
      // Get template fields from allTemplates filtered by projectId
      const templateFields = [];

      // Find templates associated with this project
      const projectTemplates = Array.isArray(allTemplates) ?
        allTemplates.filter(template => template.projectId === parseInt(project_id)) : [];

      // Extract fields from the templates
      if (projectTemplates.length > 0) {
        // Use the first template that matches the project_id
        const template = projectTemplates[0];
        if (template && Array.isArray(template.fields)) {
          // Process each field to match our field structure
          template.fields.forEach(field => {
            // Determine field type based on field properties or name
            let fieldType = field.type || "text_field";

            // Check if field is a date field based on name or type
            if (field.type === "date" ||
              field.name.toLowerCase().includes("date") ||
              field.name.toLowerCase().includes("time")) {
              fieldType = "date_field";
            }

            // Check if field is a select field
            if (field.type === "select" || Array.isArray(field.options)) {
              fieldType = "select_field";
            }

            // Process options for select fields
            let fieldOptions = [];
            if (Array.isArray(field.options)) {
              fieldOptions = field.options.map((option, index) => ({
                id: option.id || index + 1,
                name: option.name || option.toString()
              }));
            }

            templateFields.push({
              id: field.id || field.name.toLowerCase().replace(/\s+/g, '_'),
              name: field.name.toUpperCase(),
              field_type: fieldType,
              required: field.required || false,
              field_options: fieldOptions
            });
          });
        }
      }

      const boltsFields = [
        { id: "areaName", name: "AREA NAME", field_type: "text_field", required: true },
        { id: "originalPriorityId", name: "ORIGINAL PRIORITY", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "newPriorityId", name: "NEW PRIORITY", field_type: "select_field", field_options: [
          { id: 1, name: "Priority 1" },
          { id: 2, name: "Priority 2" },
          { id: 3, name: "Priority 3" }
        ] },
        { id: "unitSubtotal", name: "UNIT SUBTOTAL / NET", field_type: "text_field", required: true },
        { id: "unitWeight", name: "UNIT WEIGHT (kg)", field_type: "text_field" },
        { id: "totalWeight", name: "TOTAL WEIGHT (kg)", field_type: "text_field" },
        { id: "size", name: "SIZE", field_type: "text_field", required: true },
        { id: "length", name: "LENGTH (mm)", field_type: "text_field", required: true },
        { id: "model", name: "MODEL", field_type: "text_field" },
        { id: "materialFinish", name: "MATERIAL FINISH", field_type: "text_field", required: true },
        { id: "grade", name: "GRADE", field_type: "text_field", required: true },
        { id: "fastenerType", name: "FASTENER TYPE", field_type: "text_field", required: true },
        { id: "supplierId", name: "SUPPLIER", field_type: "select_field", field_options: [
          { id: 1, name: "Supplier 1" },
          { id: 2, name: "Supplier 2" },
          { id: 3, name: "Supplier 3" }
        ] },
        { id: "attachments", name: "ATTACHMENTS", field_type: "upload_field" },
        { id: "comments", name: "COMMENTS", field_type: "text_field" },
        { id: "status", name: "STATUS", field_type: "select_field", required: true, field_options: [
          { id: 1, name: "Active" },
          { id: 2, name: "Inactive" },
          { id: 3, name: "Pending" }
        ] },
        { id: "createdById", name: "CREATED BY", field_type: "text_field", disabled: true },
        { id: "createdDate", name: "CREATED DATE & TIME", field_type: "date_field", disabled: true },
        { id: "updatedById", name: "MODIFIED BY", field_type: "text_field", disabled: true },
        { id: "modifiedDate", name: "MODIFIED DATE & TIME", field_type: "date_field", disabled: true },
        // Add template fields
        ...templateFields
      ];
      setFields(boltsFields);
    } else {
      // For other types, clear fields
      setFields([]);
    }

    // Get current user and date/time for all form types
    const currentUser = user ? `${user.first_name} ${user.surname}` : "Joe Soap";
    const currentDateTime = moment().format("DD MMM YYYY  HH:mm");

    // Initialize form values based on type
    if (type === "Bolts") {
      // Set default values for the form fields
      const initialValues = {
        // Standard fields for bolts form
        id: record.id,
        area: record.area,
        assemblyNo: record.assemblyNo,
        revision: record.revision,
        qty: record.qty,
        materialTypeId: record.materialType ? record.materialTypeId : record.materialTypeId,
        areaName: record.areaName || record.area || "",
        originalPriorityId: record.originalPriorityId || undefined,
        newPriorityId: record.newPriorityId || undefined,
        unitSubtotal: record.unitSubtotal || "",
        unitWeight: record.unitWeight || undefined,
        totalWeight: record.totalWeight || undefined,
        size: record.size || "",
        length: record.length || "",
        model: record.model || undefined,
        materialFinish: record.materialFinish || "",
        grade: record.grade || "",
        fastenerType: record.fastenerType || "",
        supplierId: record.supplierId || undefined,
        commodityId: record.commodityId || undefined,
        attachments: record.attachments || [],
        comments: record.comments || undefined,
        status: record.status || undefined,
        createdById: currentUser,
        createdDate: moment(record.createdDate || currentDateTime),
        updatedById: "-",
        modifiedDate: record.modifiedDate ? moment(record.modifiedDate) : null
      };

      // Process any additional date fields from the record
      fields.forEach(field => {
        if (field.field_type === 'date_field' && record[field.id] && !initialValues[field.id]) {
          initialValues[field.id] = moment(record[field.id]);
        }
      });

      // Set form values
      fieldsFormRef.setFieldsValue(initialValues);
    } else if (type === "Material") {
      // Set default values for the form fields
      const initialValues = {
        id: record.id,
        area: record.area,
        assemblyNo: record.assemblyNo,
        revision: record.revision,
        uniqueId: record.uniqueId,
        qty: record.qty,
        materialTypeId: record.materialType ? record.materialTypeId : record.materialTypeId,
        areaName: record.areaName || record.area || "",
        originalPriorityId: record.originalPriorityId || undefined,
        newPriorityId: record.newPriorityId || undefined,
        unitSubtotal: record.unitSubtotal || "",
        model: record.model || undefined, 
        profileMember: record.profileMember || "",
        materialSpec: record.materialSpec || "",
        length: record.length || "",
        paintArea: record.paintArea || undefined,
        supplierId: record.supplierId || undefined,
        commodityId: record.commodityId || undefined,
        attachments: record.attachments || [],
        comments: record.comments || undefined,
        status: record.status || undefined,
        totalGross: record.qty * record.unitSubtotal || undefined,
        createdById: currentUser,
        createdDate: moment(record.createdDate || currentDateTime),
        updatedById: "-",
        modifiedDate: record.modifiedDate ? moment(record.modifiedDate) : null
      };

      // Process any additional date fields from the record
      fields.forEach(field => {
        if (field.field_type === 'date_field' && record[field.id] && !initialValues[field.id]) {
          initialValues[field.id] = moment(record[field.id]);
        }
      });

      // Set form values
      fieldsFormRef.setFieldsValue(initialValues);
    } else {
      // For other types, set basic form values
      fieldsFormRef.setFieldsValue({
        ...record,
        areaName: record.area || "",
        originalPriorityId: record.originalPriorityId || undefined,
        revision: record.revision || "",
        qty: record.qty || "",
        comments: record.comments || ""
      });
    }
  };
  
  // Function to handle form submission from expanded row
  const onFinishFields = (values) => {
  };
  
  // Function to render expanded row content
  const expandedRowRender = (record) => {
    if (expandedRowKeys.includes(record.id)) {
      return (
        <>
          {fields.length > 0 && (
            <RevisionsExpandedRow
              record={record}
              fields={fields}
              formRef={fieldsFormRef}
              onFinish={onFinishFields}
              isRevisionUpdateCase={false}
              project_id={project_id}
              isEditing={isEditing(record)}
              editingKey={editingKey}
              viewMode={viewMode}
              editingLoading={editingLoading}
            />
          )}
        </>
      );
    }
  };

  useEffect(() => {
    let order = sortedInfo?.order === "ascend" ? "asc" : "desc";
    if (record && record?.projectId) {    
      // let revision_id = doc_revisions.map((rev) => rev.id);
      dispatch(
        actions.fetchProjectRevisions({
          id: parentRecordID,
          projectId: orgRecordId,
          uniqueId,
          // search: { ...search, revision_id },
          // sort: sortedInfo?.order && sortedInfo?.columnKey,
          order: sortedInfo?.order ? order : null,
        })
      );
    } else {
      dispatch(actions.fetchProjectRevisionsSuccess([]));
    }
  }, [req]);

  useEffect(() => {
    if (parentRecordID) {
      setReq((prev) => !prev);
    }
  }, [parentRecordID]);

  const [debouncedCallApi] = useState(() =>
    _.debounce(() => setReq((prev) => !prev), 1000)
  );

  useEffect(() => {
    debouncedCallApi();
  }, [sortedInfo]);

  // Get templates from Redux store
  const { allTemplates } = useSelector((state) => state.materialTemplatesReducer);

  useEffect(() => {
    setEditingLoading(updateLoading);
    if (!updateLoading) {
      setEditingKey("");
    }

    return () => {
      handleUpdateStatus(false, false);
    };
  }, [updateLoading]);

  // Process and filter the data when allProjectRevisions or search filters change
  useEffect(() => {
    if (allProjectRevisions.length === 0) {
      setData([]);
      return;
    }
    
    // If we had an expanded row before, try to keep it expanded after data refresh
    const previouslyExpandedId = lastExpandedRowRef.current;
    
    // First, process the attachments
    let processedData = allProjectRevisions.map((el) => {
      const { revision_attachments, ...rest } = el;

      let updatedImages;
      if (revision_attachments?.length > 0) {
        updatedImages = revision_attachments.map((img) => {
          const { url, id } = img;
          let name = url.split("/")[url.split("/").length - 1].split("?")[0];

          return { key: id, id, image: url, isLocal: false, name };
        });
      }

      return { ...rest, images: updatedImages };
    });
    
    // Preserve expanded row state after data refresh
    if (previouslyExpandedId) {
      // Check if the previously expanded record still exists in the new data
      const recordStillExists = processedData.some(item => item.id === previouslyExpandedId);
      
      if (recordStillExists && expandedRowKeys.length === 0) {
        // Re-expand the row after a short delay to ensure the component has updated
        setTimeout(() => {
          setExpandedRowKeys([previouslyExpandedId]);
          
          // Set up fields for the expanded record
          const record = processedData.find(item => item.id === previouslyExpandedId);
          if (record) {
            setupFieldsForRecord(record);
          }
        }, 50);
      }
    }
    
    // Apply filters if any are active
    let filteredData = processedData;
    
    // Apply area filter if selected
    if (search.area && search.area.length > 0) {
      const selected = search.area.map(v => String(v));
      filteredData = filteredData.filter(item =>
        selected.includes(String(item && item.area != null ? item.area : ''))
      );
    }
    
    // Apply priority filter if selected
    if (search.priorityId) {
      filteredData = filteredData.filter(item => 
        item.originalPriority && item.originalPriority.id === search.priorityId
      );
    }
    
    // Apply tracking status filters
    if (search.fabricationStatuses && search.fabricationStatuses.length > 0) {
      filteredData = filteredData.filter(item => 
        item.fabricationStatus && search.fabricationStatuses.includes(item.fabricationStatus)
      );
    }
    
    if (search.qcReleaseStatuses && search.qcReleaseStatuses.length > 0) {
      filteredData = filteredData.filter(item => 
        item.qcReleaseStatus && search.qcReleaseStatuses.includes(item.qcReleaseStatus)
      );
    }
    
    if (search.corrosionProtectionStatuses && search.corrosionProtectionStatuses.length > 0) {
      filteredData = filteredData.filter(item => 
        item.corrosionProtectionStatus && search.corrosionProtectionStatuses.includes(item.corrosionProtectionStatus)
      );
    }
    
    if (search.deliveryToSiteStatuses && search.deliveryToSiteStatuses.length > 0) {
      filteredData = filteredData.filter(item => 
        item.deliveryToSiteStatus && search.deliveryToSiteStatuses.includes(item.deliveryToSiteStatus)
      );
    }
    
    if (search.siteReceiptStatuses && search.siteReceiptStatuses.length > 0) {
      filteredData = filteredData.filter(item => 
        item.siteReceiptStatus && search.siteReceiptStatuses.includes(item.siteReceiptStatus)
      );
    }

    if (search.installationStatuses && search.installationStatuses.length > 0) {
      filteredData = filteredData.filter(item => 
        item.installationStatus && search.installationStatuses.includes(item.installationStatus)
      );
    }

    // Apply string filters for Assembly No, Rev, Unique Id, Qty, Material Type, and Total/Gross
    const stringFilters = ['assemblyNo', 'revision', 'uniqueId', 'qty', 'materialType', 'totalGross'];
    
    stringFilters.forEach(filterKey => {
      if (search[filterKey] && search[filterKey].trim() !== '') {
        const searchValue = search[filterKey].toLowerCase();
        filteredData = filteredData.filter(item => {
          const itemValue = String(item[filterKey] || '').toLowerCase();
          return itemValue.includes(searchValue);
        });
      }
    });
    
    // Set the filtered data to state
    setData(filteredData);
    
    // Update area options after filtering (fetch from API for full set)
    (async () => {
      const opts = await getUniqueAreas();
      setAreaOptions(opts);
    })();
    
  }, [allProjectRevisions, search]);

  const edit = (record) => {
    const { isAdd } = record;
    if (!isAdd) {
      setCurrentUpdateObj(record);
      let filteredItems = data.filter((el) => el.id !== editingKey);
      let final = filteredItems.filter((el) => el.key !== editingKey);
      setData(final);
      setImages(record?.images || []);
    }
    const { revision_date } = record;
    form.setFieldsValue({
      ...record,
      revision_date: moment(revision_date),
      username: record?.user?.first_name + " " + record?.user?.surname,
    });
    !isAdd && handleUpdateStatus(false, true);
    setEditingKey(record.id);
  };

  const cancel = () => {
    if (isUpdateProjectRevision) {
      setData(data);
    } else {
      // if (editingKey) {
      let filteredItems = data.filter((el) => el.id !== editingKey);
      let final = filteredItems.filter((el) => el.key !== editingKey);
      setData(final);
      // }
    }
    handleUpdateStatus(false, false);
    setEditingKey("");
  };

  const save = async (key) => {
    setEditingKey(key);
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex(
        (item) => key === item.key || key === item.id
      );
      if (index > -1) {
        form.submit();
      } else {
        // newData.push(row);
        // setData(newData);
        // setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  // Dropdown content components will be defined later after all filter functions

  const searchInput = (key) => {
    if (key === "area") {
      return (
        <Dropdown 
          overlay={areaDropdownContent} 
          trigger={['click']} 
          visible={areaDropdownVisible}
          onVisibleChange={(visible) => {
            // Only update if the dropdown is being opened or closed by clicking outside
            // This prevents the dropdown from closing when clicking inside it
            if (!visible || !areaDropdownVisible) {
              setAreaDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '350px' }}
        >
          <Input
            placeholder={""}
            value={selectedAreas.length > 0 ? selectedAreas.length : ""}
            readOnly
            className="area-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "fabrication") {
      return (
        <Dropdown 
          overlay={fabricationDropdownContent} 
          trigger={['click']} 
          visible={fabricationDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !fabricationDropdownVisible) {
              setFabricationDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={fabricationStatusFilter.length > 0 ? fabricationStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "qcRelease") {
      return (
        <Dropdown 
          overlay={qcReleaseDropdownContent} 
          trigger={['click']} 
          visible={qcReleaseDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !qcReleaseDropdownVisible) {
              setQcReleaseDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={qcReleaseStatusFilter.length > 0 ? qcReleaseStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "corrosionProtection") {
      return (
        <Dropdown 
          overlay={corrosionProtectionDropdownContent} 
          trigger={['click']} 
          visible={corrosionProtectionDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !corrosionProtectionDropdownVisible) {
              setCorrosionProtectionDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={corrosionProtectionStatusFilter.length > 0 ? corrosionProtectionStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "deliveryToSite") {
      return (
        <Dropdown 
          overlay={deliveryToSiteDropdownContent} 
          trigger={['click']} 
          visible={deliveryToSiteDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !deliveryToSiteDropdownVisible) {
              setDeliveryToSiteDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={deliveryToSiteStatusFilter.length > 0 ? deliveryToSiteStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "siteReceipt") {
      return (
        <Dropdown 
          overlay={siteReceiptDropdownContent} 
          trigger={['click']} 
          visible={siteReceiptDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !siteReceiptDropdownVisible) {
              setSiteReceiptDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={siteReceiptStatusFilter.length > 0 ? siteReceiptStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    } else if (key === "installation") {
      return (
        <Dropdown 
          overlay={installationDropdownContent} 
          trigger={['click']} 
          visible={installationDropdownVisible}
          onVisibleChange={(visible) => {
            if (!visible || !installationDropdownVisible) {
              setInstallationDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{minWidth: '300px' }}
        >
          <Input
            placeholder={""}
            value={installationStatusFilter.length > 0 ? installationStatusFilter.length : ""}
            readOnly
            className="tracking-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    }
    
    // For all other string inputs
    return (
      <Input
        placeholder={""}
        onClick={(e) => e.stopPropagation()}
        value={search[key] || ""}
        onChange={(e) => {
          setSearch({
            ...search,
            [key]: e.target.value,
          });
          // No need to call API since we're filtering client-side
        }}
      />
    );
  };

  const handleDateInput = (value) => {
    setDate(value);
    if (value === null) {
      setSearch({
        ...search,
        revision_start_date: "",
        revision_end_date: "",
      });
    } else {
      setSearch({
        ...search,
        revision_start_date: value[0],
        revision_end_date: value[1],
      });
    }
    debouncedCallApi();
  };

  const handleMultiSelect = (list, key) => {
    setSearch({
      ...search,
      [key]: list,
    });
    // debouncedCallApi();
  };

  const handleSelectOnchange = (value, options, key, setHandler) => {
    if (value.includes("all")) {
      setHandler([...options.map((item) => item.value)]);
      value = options.map((item) => item.value);
    } else if (value.includes("not-all")) {
      setHandler([]);
      value = [];
    } else {
      setHandler(value);
    }
    handleMultiSelect(value, key);
  };

  const onDeleteSuccess = () => {
    setDeleteActivityId();
    debouncedCallApi();
  };

  const deleteRevisionHandler = (record) => {
    setDeleteActivityId(record.id);
    dispatch(
      actions.deleteProjectRevision({
        ...record,
        onDeleteSuccess,
        parentRecordID,
      })
    );
  };

  // Keep the revisionButtonRef which wasn't moved to the top
  const revisionButtonRef = useRef(null);
  
  // Apply tracking stage filter functions
  const applyFabricationFilter = () => {
    setSearch({
      ...search,
      fabricationStatuses: fabricationStatusFilter.length > 0 ? fabricationStatusFilter : undefined
    });
    setFabricationDropdownVisible(false);
  };

  const applyQcReleaseFilter = () => {
    setSearch({
      ...search,
      qcReleaseStatuses: qcReleaseStatusFilter.length > 0 ? qcReleaseStatusFilter : undefined
    });
    setQcReleaseDropdownVisible(false);
  };

  const applyCorrosionProtectionFilter = () => {
    setSearch({
      ...search,
      corrosionProtectionStatuses: corrosionProtectionStatusFilter.length > 0 ? corrosionProtectionStatusFilter : undefined
    });
    setCorrosionProtectionDropdownVisible(false);
  };

  const applyDeliveryToSiteFilter = () => {
    setSearch({
      ...search,
      deliveryToSiteStatuses: deliveryToSiteStatusFilter.length > 0 ? deliveryToSiteStatusFilter : undefined
    });
    setDeliveryToSiteDropdownVisible(false);
  };

  const applySiteReceiptFilter = () => {
    setSearch({
      ...search,
      siteReceiptStatuses: siteReceiptStatusFilter.length > 0 ? siteReceiptStatusFilter : undefined
    });
    setSiteReceiptDropdownVisible(false);
  };

  const applyInstallationFilter = () => {
    setSearch({
      ...search,
      installationStatuses: installationStatusFilter.length > 0 ? installationStatusFilter : undefined
    });
    setInstallationDropdownVisible(false);
  };
  
  // Handle tracking status checkbox change
  const handleTrackingStatusCheckboxChange = (status, currentSelection, setSelection) => {
    const newSelection = [...currentSelection];
    const statusIndex = newSelection.indexOf(status);
    
    if (statusIndex === -1) {
      newSelection.push(status);
    } else {
      newSelection.splice(statusIndex, 1);
    }
    
    setSelection(newSelection);
  };

  // Handle Select All checkbox for tracking stages
  const handleSelectAllTrackingStatus = (e, setSelection) => {
    if (e.target.checked) {
      setSelection(trackingStatusOptions.map(option => option.value));
    } else {
      setSelection([]);
    }
  };
  
  // Fetch project priorities
  useEffect(() => {
    const fetchPriorities = async () => {
      if (project_id) {
        try {
          const response = await axios.get(`/project/${project_id}`);
          if (response.status === 200) {
            const formattedPriorities = response.data.priorities.map(priority => ({
              label: priority.name || '',
              value: priority.id
            }));
            setPriorities(formattedPriorities);
          }
        } catch (error) {
          console.error('Error fetching project priorities:', error);
        }
      }
    };
    
    fetchPriorities();
  }, [project_id]);

  const handlePrioritySelect = (priority) => {
    // If the same priority is selected, clear it
    if (selectedPriority === priority) {
      setSelectedPriority(null);
    } else {
      // Otherwise set the new selected priority
      setSelectedPriority(priority);
    }
    
    // Close dropdown after selection
    setPriorityDropdownVisible(false);
    
    // Apply filter immediately
    setSearch(prev => ({
      ...prev,
      priorityId: priority || undefined
    }));
  };

  // Clear priority filter
  const clearPriorityFilter = () => {
    setSelectedPriority(null);
    setSearch(prev => ({
      ...prev,
      priorityId: undefined
    }));
    setPriorityDropdownVisible(false);
  };

  // Custom dropdown content for priorities
  const priorityDropdownContent = (
    <div className="priority-dropdown-content" style={{ background: '#fff', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)', borderRadius: '4px' }}>
      <div className="priority-dropdown-content-body" style={{ padding: '8px 0' }}>
        {priorities.map(option => (
          <div 
            key={option.value} 
            className={`priority-option ${selectedPriority === option.value ? 'selected' : ''}`}
            onClick={() => handlePrioritySelect(option.value)}
            style={{ 
              cursor: 'pointer', 
              padding: '8px 12px',
              backgroundColor: selectedPriority === option.value ? '#f5f5f5' : 'transparent',
              transition: 'background-color 0.3s'
            }}
          >
            {option.label}
          </div>
        ))}
      </div>
    </div>
  );


  // Fetch all areas for the dropdown using the dedicated areas API endpoint
  const getUniqueAreas = async () => {
    try {
      if (!project_id) return [];

      const { data: resp } = await axios.get(`/material-control-registers/areas`, {
        params: {
          projectId: project_id
        }
      });
      const items = resp?.data || [];

      // Return all records from the API (not deduplicated)
      return items.map((item, index) => ({
        label: `${item.area} - ${item.areaName}`,
        value: `${item.area}-${item.areaName}-${index}`, // Use a composite value to ensure uniqueness
        area: item.area, // Store original area for filtering
        areaName: item.areaName, // Store original areaName
      }));
    } catch (e) {
      console.error('Failed to fetch areas', e);
      return [];
    }
  };
  
  // Update area options when project changes (fetch once, not per page)
  useEffect(() => {
    let mounted = true;
    (async () => {
      const opts = await getUniqueAreas();
      if (mounted) setAreaOptions(opts);
    })();
    return () => { mounted = false; };
  }, [project_id]);
  
  // Handle area checkbox change
  const handleAreaCheckboxChange = (area) => {
    const updatedSelectedAreas = [...selectedAreas];
    const areaIndex = updatedSelectedAreas.indexOf(area);
    
    if (areaIndex === -1) {
      updatedSelectedAreas.push(area);
    } else {
      updatedSelectedAreas.splice(areaIndex, 1);
    }
    
    setSelectedAreas(updatedSelectedAreas);
  };
  
  // Handle select all areas
  const handleSelectAllAreas = (e) => {
    if (e.target.checked) {
      // store only values, not option objects
      setSelectedAreas(areaOptions.map(opt => opt.value));
    } else {
      setSelectedAreas([]);
    }
  };
  
  // Apply area filter
  const applyAreaFilter = () => {
    setAreaDropdownVisible(false); // Close the dropdown

    if (selectedAreas.length > 0) {
      // Extract the original area values from selected composite values
      const areaValues = selectedAreas.map(compositeValue => {
        // Extract the area from the composite value (format: area-areaName-index)
        const option = areaOptions.find(opt => opt.value === compositeValue);
        return option ? option.area : compositeValue.split('-')[0];
      });
      
      // apply via functional update
      setSearch(prev => ({
        ...prev,
        area: areaValues
      }));
    } else {
      // remove the area filter key
      setSearch(prev => {
        const { area, ...rest } = prev || {};
        return rest;
      });
    }
  };
  

  
  // Local filtered data state
  const [filteredData, setFilteredData] = useState([]);
  
  // Clear area filter
  const clearAreaFilter = () => {
    setSelectedAreas([]);
    const { area, ...restSearch } = search;
    setSearch(restSearch);
  };
  
  // Define dropdown content components after all filter functions are defined
  
  // Custom dropdown content for Fabrication status
  const fabricationDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={(e) => handleSelectAllTrackingStatus(e, setFabricationStatusFilter)}
          checked={fabricationStatusFilter.length === trackingStatusOptions.length && trackingStatusOptions.length > 0}
          indeterminate={fabricationStatusFilter.length > 0 && fabricationStatusFilter.length < trackingStatusOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {trackingStatusOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={fabricationStatusFilter.includes(option.value)}
              onChange={() => handleTrackingStatusCheckboxChange(option.value, fabricationStatusFilter, setFabricationStatusFilter)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyFabricationFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );
  
  // Custom dropdown content for QC Release status
  const qcReleaseDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={(e) => handleSelectAllTrackingStatus(e, setQcReleaseStatusFilter)}
          checked={qcReleaseStatusFilter.length === trackingStatusOptions.length && trackingStatusOptions.length > 0}
          indeterminate={qcReleaseStatusFilter.length > 0 && qcReleaseStatusFilter.length < trackingStatusOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {trackingStatusOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={qcReleaseStatusFilter.includes(option.value)}
              onChange={() => handleTrackingStatusCheckboxChange(option.value, qcReleaseStatusFilter, setQcReleaseStatusFilter)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyQcReleaseFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );
  
  // Custom dropdown content for Corrosion Protection status
  const corrosionProtectionDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={(e) => handleSelectAllTrackingStatus(e, setCorrosionProtectionStatusFilter)}
          checked={corrosionProtectionStatusFilter.length === trackingStatusOptions.length && trackingStatusOptions.length > 0}
          indeterminate={corrosionProtectionStatusFilter.length > 0 && corrosionProtectionStatusFilter.length < trackingStatusOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {trackingStatusOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={corrosionProtectionStatusFilter.includes(option.value)}
              onChange={() => handleTrackingStatusCheckboxChange(option.value, corrosionProtectionStatusFilter, setCorrosionProtectionStatusFilter)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyCorrosionProtectionFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );
  
  // Custom dropdown content for Delivery to Site status
  const deliveryToSiteDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={(e) => handleSelectAllTrackingStatus(e, setDeliveryToSiteStatusFilter)}
          checked={deliveryToSiteStatusFilter.length === trackingStatusOptions.length && trackingStatusOptions.length > 0}
          indeterminate={deliveryToSiteStatusFilter.length > 0 && deliveryToSiteStatusFilter.length < trackingStatusOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {trackingStatusOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={deliveryToSiteStatusFilter.includes(option.value)}
              onChange={() => handleTrackingStatusCheckboxChange(option.value, deliveryToSiteStatusFilter, setDeliveryToSiteStatusFilter)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyDeliveryToSiteFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );
  
  // Custom dropdown content for Site Receipt status
  const siteReceiptDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={(e) => handleSelectAllTrackingStatus(e, setSiteReceiptStatusFilter)}
          checked={siteReceiptStatusFilter.length === trackingStatusOptions.length && trackingStatusOptions.length > 0}
          indeterminate={siteReceiptStatusFilter.length > 0 && siteReceiptStatusFilter.length < trackingStatusOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {trackingStatusOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={siteReceiptStatusFilter.includes(option.value)}
              onChange={() => handleTrackingStatusCheckboxChange(option.value, siteReceiptStatusFilter, setSiteReceiptStatusFilter)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applySiteReceiptFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );

  // Custom dropdown content for Installation status
  const installationDropdownContent = (
    <div className="tracking-dropdown-content">
      <div className="tracking-dropdown-content-header">
        <Checkbox 
          onChange={(e) => handleSelectAllTrackingStatus(e, setInstallationStatusFilter)}
          checked={installationStatusFilter.length === trackingStatusOptions.length && trackingStatusOptions.length > 0}
          indeterminate={installationStatusFilter.length > 0 && installationStatusFilter.length < trackingStatusOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="tracking-dropdown-content-body">
        {trackingStatusOptions.map(option => (
          <div key={option.value} className="tracking-option">
            <Checkbox 
              checked={installationStatusFilter.includes(option.value)}
              onChange={() => handleTrackingStatusCheckboxChange(option.value, installationStatusFilter, setInstallationStatusFilter)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="tracking-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyInstallationFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );
  
  // Custom dropdown content for areas
  const areaDropdownContent = (
    <div className="area-dropdown-content">
      <div className="area-dropdown-content-header">
        <Checkbox 
          onChange={handleSelectAllAreas}
          checked={selectedAreas.length === areaOptions.length && areaOptions.length > 0}
          indeterminate={selectedAreas.length > 0 && selectedAreas.length < areaOptions.length}
        >
          Select All
        </Checkbox>
      </div>
      <div className="area-dropdown-content-body">
        {areaOptions.map(option => (
          <div key={option.value} className="area-option">
            <Checkbox 
              checked={selectedAreas.includes(option.value)}
              onChange={() => handleAreaCheckboxChange(option.value)}
            >
              {option.label}
            </Checkbox>
          </div>
        ))}
      </div>
      <div className="area-dropdown-content-footer">
        <Button 
          type="default" 
          onClick={applyAreaFilter}
          className="done-button"
        >
          DONE
        </Button>
      </div>
    </div>
  );

  // Function to find the last active step index in progressSteps
  const findLastActiveStepIndex = (progressSteps) => {
    if (!progressSteps || !progressSteps.length) return -1;
    
    let lastActiveIndex = -1;
    for (let i = progressSteps.length - 1; i >= 0; i--) {
      if (progressSteps[i] && (progressSteps[i].status === 'in_progress' || progressSteps[i].status === 'completed' || progressSteps[i].status === 'received')) {
        lastActiveIndex = i;
        break;
      }
    }
    return lastActiveIndex;
  };

  // Function to render tracking stage status with appropriate icon and date
  const renderTrackingStageStatus = (stage, record, isLastActiveStep, stageType) => {
    // Handle case where record is On Hold but no progress stages exist
    if (!stage && record && record.status === 'On Hold') {
      // Only show On Hold icon for Fabrication stage when no progress steps exist
      if (stageType === 'Fabrication') {
        return (
          <div className="tracking-status" style={{ color: '#e20f00' }}>
            <img src={OnHoldIcon} alt="On Hold" style={{ width: '22px', height: '20px' }} />
            <div>{moment().format('D MMM YY')}</div>
          </div>
        );
      }
      return null;
    }
    
    if (!stage) return null;
    
    const { status } = stage;
    
    // Check if the record status is 'On Hold' and this is the last active step
    if (record && record.status === 'On Hold' && isLastActiveStep) {
      // Use the date from the step or current date if not available
      const onHoldAt = stage.completedAt || stage.receivedAt ? 
        moment(stage.completedAt || stage.receivedAt).format('D MMM YY') : 
        moment().format('D MMM YY');
      
      return (
        <div className="tracking-status" style={{ color: '#e20f00' }}>
          <img src={OnHoldIcon} alt="On Hold" style={{ width: '22px', height: '20px' }} />
          <div>{onHoldAt}</div>
        </div>
      );
    }
    
    if (status === 'received') {
      const receivedDate = stage.receivedAt ? moment(stage.receivedAt).format('D MMM YY') : '';
      return (
        <div className="tracking-status received">
          <img src={ReceivedIcon} alt="Received" style={{ width: '22px', height: '20px' }} />
          <div>{receivedDate}</div>
        </div>
      );
    }
    
    if (status === 'in_progress') {
      const inProgressDate = stage.completedAt ? moment(stage.completedAt).format('D MMM YY') : '';
      return (
        <div className="tracking-status in-progress">
          <img src={InProgressIcon} alt="In Progress" style={{ width: '22px', height: '20px' }} />
          <div>{inProgressDate}</div>
        </div>
      );
    }
    
    if (status === 'completed') {
      const completedDate = stage.completedAt ? moment(stage.completedAt).format('D MMM YY') : '';
      return (
        <div className="tracking-status completed">
          <img src={CompletedIcon} alt="Completed" style={{ width: '22px', height: '20px' }} />
          <div>{completedDate}</div>
        </div>
      );
    }
    
    return status;
  };

  // Function to calculate percentage completion based on tracking stages
  const calculatePercentComplete = (record) => {
    if (!record || !record.progressSteps) return 0;
    
    let percentComplete = 0;
    const { progressSteps } = record;
    
    // Check each stage and add percentage if completed
    // fabrication - 10%
    if (progressSteps[0] && (progressSteps[0].status === 'in_progress' || progressSteps[0].status === 'completed')) {
      percentComplete += 10;
    }
    
    // qcRelease - 10%
    if (progressSteps[1] && (progressSteps[1].status === 'in_progress' || progressSteps[1].status === 'completed')) {
      percentComplete += 10;
    }
    
    // corrosionProtection - 40%
    if (progressSteps[2] && (progressSteps[2].status === 'in_progress' || progressSteps[2].status === 'completed')) {
      percentComplete += 20;
    }
    
    // deliveryToSite - 60%
    if (progressSteps[3] && (progressSteps[3].status === 'in_progress' || progressSteps[3].status === 'completed')) {
      percentComplete += 20;
    }
    
    // siteReceipt - 80%
    if (progressSteps[4] && (progressSteps[4].status === 'in_progress' || progressSteps[4].status === 'completed')) {
      percentComplete += 20;
    }

    // installation - 100%
    if (progressSteps[5] && (progressSteps[5].status === 'in_progress' || progressSteps[5].status === 'completed')) {
      percentComplete += 20;
    }
    
    return percentComplete;
  };

  const columns = [
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(0)}</div>
            <div>
              <Dropdown 
                overlay={areaDropdownContent} 
                trigger={['click']} 
                visible={areaDropdownVisible}
                onVisibleChange={(visible) => {
                  // Only update if the dropdown is being opened or closed by clicking outside
                  // This prevents the dropdown from closing when clicking inside it
                  if (!visible || !areaDropdownVisible) {
                    setAreaDropdownVisible(visible);
                  }
                }}
                placement="bottomLeft"
                overlayStyle={{minWidth: '350px' }}
              >
                <Input
                  placeholder={""}
                  value={selectedAreas.length > 0 ? selectedAreas.length : ""}
                  readOnly
                  className="area-dropdown-trigger"
                  onClick={(e) => e.stopPropagation()}
                />
              </Dropdown>
            </div>
          </div>
        );
      },
      dataIndex: "area",
      key: "area",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "area" && sortedInfo?.order,
      width: 100,
      editable: true,
      render: (area, record) => (
        <div onClick={(e) => handleColOnClick(record, e)}>{area}</div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(1)}</div>
            <div>{searchInput("assemblyNo")}</div>
          </div>
        );
      },
      dataIndex: "assemblyNo",
      key: "assemblyNo",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "assemblyNo" && sortedInfo?.order,
      width: 100,
      editable: true,
      render: (assemblyNo, record) => (
        <div onClick={(e) => handleColOnClick(record, e)}>{assemblyNo}</div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(2)}</div>
            <div>{searchInput("revision")}</div>
          </div>
        );
      },
      dataIndex: "revision",
      key: "revision",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "revision" && sortedInfo?.order,
      width: 100,
      editable: true,
      render: (revision, record) => (
        <div onClick={(e) => handleColOnClick(record, e)}>
          {record?.revision}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(3)}</div>
            <div>{searchInput("uniqueId")}</div>
          </div>
        );
      },
      dataIndex: "uniqueId",
      key: "uniqueId",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "uniqueId" && sortedInfo?.order,
      width: 100,
      editable: false,
      render: (uniqueId, record) => (
        <div onClick={(e) => handleColOnClick(record, e)}>
          {record?.uniqueId}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(4)}</div>
            <div>{searchInput("qty")}</div>
          </div>
        );
      },
      dataIndex: "qty",
      key: "qty",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "qty" && sortedInfo?.order,
      width: 80,
      editable: true,
      render: (qty, record) => (
        <div onClick={(e) => handleColOnClick(record, e)}>
          {record?.qty}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(5)}</div>
            <div>{searchInput("materialType")}</div>
          </div>
        );
      },
      dataIndex: "materialTypeId",
      key: "materialTypeId",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "materialTypeId" && sortedInfo?.order,
      width: 80,
      editable: true,
      render: (materialTypeId, record) => (
        <div onClick={(e) => handleColOnClick(record, e)}>{record.materialType ? record.materialType.materialType : materialTypeId}</div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(6)}</div>
            <div>{searchInput("totalGross")}</div>
          </div>
        );
      },
      dataIndex: "totalGross",
      key: "totalGross",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "totalGross" && sortedInfo?.order,
      width: 50,
      align: "center",
      editable: true,
      render: (totalGross, record) => {
        return (
          <div onClick={() => handleColOnClick(record)}>
            {record?.type === "material" || record?.type === "Material" && record?.materialType?.uom ?
              record?.totalGross + " " + record?.materialType?.uom :
              record?.totalGross
            }
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(7)}</div>
            <div>
              <Dropdown 
                overlay={priorityDropdownContent} 
                trigger={['click']} 
                visible={priorityDropdownVisible}
                onVisibleChange={(visible) => {
                  if (!visible || !priorityDropdownVisible) {
                    setPriorityDropdownVisible(visible);
                  }
                }}
                placement="bottomLeft"
                overlayStyle={{
                  minWidth: '350px',
                  backgroundColor: '#fff',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                  borderRadius: '4px'
                }}
              >
                <div style={{ position: 'relative' }}>
                  <Input
                    placeholder={""}
                    value={selectedPriority ? priorities.find(p => p.value === selectedPriority)?.label || '' : ""}
                    readOnly
                    className="priority-dropdown-trigger"
                    suffix={
                      selectedPriority && (
                        <CloseCircleFilled
                          onClick={(e) => {
                            e.stopPropagation();
                            clearPriorityFilter();
                          }}
                          style={{ color: '#999', cursor: 'pointer' }}
                        />
                      )
                    }
                  />
                </div>
              </Dropdown>
            </div>
          </div>
        );
      },
      dataIndex: null,
      key: null,
      sorter: true,
      // sortOrder: sortedInfo?.columnKey === "priority" && sortedInfo?.order,
      width: 165, // "8%"
      align: "left",
      editable: true,
      className: "less-padding-col",
      render: (priority, record) => (
        <div onClick={() => handleColOnClick(record)}>
          {record?.originalPriority && (
            <div
              className="priority-badge"
              style={{
                backgroundColor: record.originalPriority.color || '#D9D9D9',
                color: '#000',
                border: 'none'
              }}
            >
              {record.originalPriority.name}
            </div>
          )}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(8)}</div>
            <div>{searchInput("fabrication")}</div>
          </div>
        );
      },
      dataIndex: null,
      key: null,
      sorter: true,
      // sortOrder: sortedInfo?.columnKey === "fabrication" && sortedInfo?.order,
      width: 210,
      className: "comment-td less-padding-col",
      editable: true,
      render: (fabrication, record) => {
        const lastActiveStepIndex = findLastActiveStepIndex(record?.progressSteps);
        return (
          <div onClick={() => handleColOnClick(record)}>
            {renderTrackingStageStatus(record?.progressSteps?.[0], record, lastActiveStepIndex === 0, 'Fabrication')}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(9)}</div>
            <div>{searchInput("qcRelease")}</div>
          </div>
        );
      },
      dataIndex: null,
      key: null,
      sorter: true,
      // sortOrder: sortedInfo?.columnKey === "qcRelease" && sortedInfo?.order,
      width: 90,
      editable: true,
      align: "center",
      render: (qcRelease, record) => {
        const lastActiveStepIndex = findLastActiveStepIndex(record?.progressSteps);
        return (
          <div onClick={() => handleColOnClick(record)}>
            {renderTrackingStageStatus(record?.progressSteps?.[1], record, lastActiveStepIndex === 1, 'QC Release')}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(10)}</div>
            <div>{searchInput("corrosionProtection")}</div>
          </div>
        );
      },
      dataIndex: null,
      key: null,
      sorter: true,
      // sortOrder: sortedInfo?.columnKey === "corrosionProtection" && sortedInfo?.order,
      width: 90,
      editable: true,
      align: "center",
      render: (corrosionProtection, record) => {
        const lastActiveStepIndex = findLastActiveStepIndex(record?.progressSteps);
        return (
          <div onClick={() => handleColOnClick(record)}>
            {renderTrackingStageStatus(record?.progressSteps?.[2], record, lastActiveStepIndex === 2, 'Corrosion Protection')}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(11)}</div>
            <div>{searchInput("deliveryToSite")}</div>
          </div>
        );
      },
      dataIndex: null,
      key: null,
      sorter: true,
      // sortOrder: sortedInfo?.columnKey === "deliveryToSite" && sortedInfo?.order,
      width: 90,
      editable: true,
      align: "center",
      render: (deliveryToSite, record) => {
        const lastActiveStepIndex = findLastActiveStepIndex(record?.progressSteps);
        return (
          <div onClick={() => handleColOnClick(record)}>
            {renderTrackingStageStatus(record?.progressSteps?.[3], record, lastActiveStepIndex === 3, 'Delivery to Site')}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(12)}</div>
            <div>{searchInput("siteReceipt")}</div>
          </div>
        );
      },
      dataIndex: null,
      key: null,
      sorter: true,
      // sortOrder: sortedInfo?.columnKey === "siteReceipt" && sortedInfo?.order,
      width: 90,
      editable: true,
      align: "center",
      render: (siteReceipt, record) => {
        const lastActiveStepIndex = findLastActiveStepIndex(record?.progressSteps);
        return (
          <div onClick={() => handleColOnClick(record)}>
            {renderTrackingStageStatus(record?.progressSteps?.[4], record, lastActiveStepIndex === 4, 'Site Receipt')}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(13)}</div>
            <div>{searchInput("perComplete")}</div>
          </div>
        );
      },
      dataIndex: "perComplete",
      key: "perComplete",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "perComplete" && sortedInfo?.order,
      width: 90,
      editable: true,
      align: "center",
      render: (perComplete, record) => {
        return (
          <div onClick={() => handleColOnClick(record)}>{`${record.perComplete || 0}%`}</div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(14)}</div>
            <div>{searchInput("perInstalled")}</div>
          </div>
        );
      },
      dataIndex: "perInstalled",
      key: "perInstalled",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "perInstalled" && sortedInfo?.order,
      width: 90,
      editable: true,
      align: "center",
      render: (perInstalled, record) => {
        return (
          <div onClick={() => handleColOnClick(record)}>{`${record.perInstalled || 0}%`}</div>
        );
      },
    }
  ];

  // Fetch revision types when component mounts
  useEffect(() => {
    // Set static revision options
    setRevisionOptions([
      { id: 1, name: 'New Revision' }
    ]);
  }, []);

  // Handle showing the dropdown
  const handleAdd = (e) => {
    e.stopPropagation();
    const rect = addRevisionButtonRef.current.getBoundingClientRect();
    setDropdownPosition({
      top: rect.top + window.scrollY,
      left: rect.right + window.scrollX + 4 // Adding 4px margin
    });
    setRevisionDropdownVisible(!revisionDropdownVisible);
  };
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (revisionDropdownVisible && 
          addRevisionButtonRef.current && 
          !addRevisionButtonRef.current.contains(event.target) &&
          !event.target.closest('.revisions-dropdown')) {
        setRevisionDropdownVisible(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [revisionDropdownVisible]);
  
  // Handle selecting a revision type
  const handleRevisionTypeSelect = (revisionType) => {
    // Close dropdown
    setRevisionDropdownVisible(false);
    
    // Dispatch action to open the main form with the current type, record, and selected revision type
    dispatch({ 
      type: "OPEN_MAIN_FORM", 
      payload: { 
        type, 
        record,
        revisionType 
      } 
    });
    console.log("Opening main form with type:", type, "and record:", record, "and revision type:", revisionType);
  };
  
  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (revisionButtonRef.current && !revisionButtonRef.current.contains(event.target)) {
        setRevisionDropdownVisible(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => {
        return {
          record,
          // inputType:,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
        };
      },
    };
  });

  const handleFinish = (item) => {
    const { revision_date } = item;
    if (isUpdateProjectRevision) {
      dispatch(
        actions.updateProjectRevision({
          ...item,
          revision_date: moment(revision_date),
          id: currentUpdateObj.id,
          ...(images.length > 0 && { images }),
          parentRecordID,
          debouncedCallApi,
        })
      );
    } else {
      dispatch(
        actions.createProjectRevision({
          ...item,
          revision_date: moment(revision_date),
          ...(images.length > 0 && { images }),
          parentRecordID,
          // debouncedCallApi,
        })
      );
    }
  };
  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  return (
    <Row className="revisions-parent-row">
      <Col span={24} className="heading-col">
        <Row align="middle">
          <Col>
            <div className="revisions-heading-div">
              <div onClick={() => setShowTable(!showTable)}>
                {showTable ? (
                  <UpCircleOutlined className="revision-up-down-icon" />
                ) : (
                  <DownCircleOutlined className="revision-up-down-icon" />
                )}
              </div>
              <div>
                <span className="heading-span">
                  Revisions{" "}
                  {allProjectRevisions.length > 0 &&
                    `(${allProjectRevisions.length})`}
                </span>
              </div>
            </div>
          </Col>
          {canEdit && mcPermissions?.edit?.add_revisions && (
            <Col>
              <div>
                <Button
                  ref={addRevisionButtonRef}
                  icon={<PlusOutlined />}
                  className="add-revisions-btn"
                  size="small"
                  onClick={handleAdd}
                  disabled={
                    isAddProjectRevision ||
                    fetchingLoading ||
                    isUpdateProjectRevision
                  }
                >
                  Revision
                </Button>
                
                {revisionDropdownVisible && ReactDOM.createPortal(
                  <div 
                    className="revisions-dropdown"
                    style={{
                      top: `${dropdownPosition.top}px`,
                      left: `${dropdownPosition.left}px`
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="revisions-dropdown-content">
                      <div className="revisions-dropdown-header">
                        <h5>
                          <span className="revisions-dropdown-icon">!</span>
                          Add New Revision
                        </h5>
                      </div>
                      
                      <div className="revisions-dropdown-body">
                        <div className="revisions-dropdown-text">
                          <p className="heading">You are about to add a New Revision.</p>
                          <p>The Current Revision will no longer be editable once the New Revision has been added.</p>
                          <p>Please note this action cannot be undone.</p>
                          <p className="heading">Are you sure that you want to add a New Revision?</p>
                        </div>
                      </div>
                      
                      <div className="revisions-dropdown-footer">
                        <button 
                          onClick={() => handleRevisionTypeSelect(revisionOptions[0])}
                          className="confirm-button"
                        >
                          Yes, I'm sure
                        </button>
                        <button 
                          onClick={() => setRevisionDropdownVisible(false)}
                          className="cancel-button"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>,
                  document.body
                )}
              </div>
            </Col>
          )}
        </Row>
      </Col>

      {showTable && (
        <Col span={24}>
          <Form form={form} component={false} onFinish={handleFinish}>
            <Table
              scroll={{ x: 1200 }}
              className="special-table ims-doc-table revisions-table"
              components={{
                body: {
                  cell: (props) => (
                    <RevisionsEditableCell
                      cell={props}
                      images={images}
                      setImages={setImages}
                      attachPopupVisible={attachPopupVisible}
                      setAttachPopupVisible={setAttachPopupVisible}
                      currentUpdateObj={currentUpdateObj}
                      values={form.getFieldsValue()}
                    />
                  ),
                },
              }}
              expandable={{
                expandedRowRender,
                expandIcon: null,
                showExpandColumn: false,
                expandedRowKeys: expandedRowKeys,
                rowExpandable: ({ id }) => expandedRowKeys.includes(id),
              }}
              onRow={({ id }) =>
                expandedRowKeys.includes(id) && {
                  className: `expand-doc-parent`,
                }
              }
              rowKey={(record) => record.id}
              loading={fetchingLoading}
              rowClassName="editable-row"
              dataSource={data}
              columns={mergedColumns}
              onChange={handleChange}
              pagination={false}
            />
          </Form>
        </Col>
      )}
    </Row>
  );
}

export default RivisionsTable;
